
<div class="creditor-claimant-wrapper">
  <div class="container-md px-5 px-md-0">
    <app-header [header-data]="headerData1"></app-header>
    <div class="{{ headerData?.isSubHeaderRight ? 'col-md-10' : 'col-md-12' }}">
      <div class="container-fluid">
        <div class="row">
          <button class="claim-button ml-auto"
                  *ngIf="headerData?.subHeaderButtonText && accountmanagerOrDelegates" (click)="redirectToAdjudicationSummmaryPopup()">
                  <img src="../../../../assets/images/creditor-portal/Add Claim.svg" alt="Add">
            {{headerData?.subHeaderButtonText}}
          </button>
        </div>
      </div>
      <p class="m-0" *ngIf="headerData?.headThreeDesc">{{headerData?.headThreeDesc}}</p>
      </div>
        <div   class="table-one-wrapper scroll-table sd-table">
          <div class="table-wrapper">
              <div class="table-responsive">
                  
              <table mat-table  [dataSource]="dataSource" matSort (matSortChange)="onClickToSortHeader($event)" class="mat-elevation-z8 base-table">

                    <ng-container matColumnDef="broadCastName">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{labelCaption.CPProxyForm_BroadCastName}}
                          </th>
                          <td mat-cell *matCellDef="let element" [ngStyle]="{'background-color':element.isSuperseded ?'normal':'#ccd0d3' }">
                            <div class="txt-wrapp" [ngStyle]="{'text-decoration': !element.isSuperseded ? 'line-through' : 'none'}">
                                <a class="nav-link txt-wrapp pointer" 
                                [innerHTML]="element.broadcastName" (click)="redirectToProxyDetailPage(element.proxyFormId)"></a>
                            </div>
                        </td>
                      </ng-container>
                    

                      <ng-container matColumnDef="documentType"> 
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{labelCaption.CPProxyForm_DocumentType}}
                          </th>
                          <td mat-cell *matCellDef="let element" [ngStyle]="{'background-color':element.isSuperseded ?'normal':'#ccd0d3' }" >
                          <div class="txt-wrap" [ngStyle]="{'text-decoration': !element.isSuperseded ? 'line-through' : 'none'}">
                              {{element.documentType}} 
                              <div class="tooltiptext" [innerHTML]="element.engagement"></div>
                          </div>
                          </td>
                      </ng-container>
                  
                      <ng-container matColumnDef="fileName">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{labelCaption.CPProxyForm_FileName}}
                          </th>
                          <td mat-cell *matCellDef="let element" [ngStyle]="{'background-color':element.isSuperseded ?'normal':'#ccd0d3' }">
                          <div class="txt-wrap" [ngStyle]="{'text-decoration': !element.isSuperseded ? 'line-through' : 'none'}">
                              <a  (click)="downloadFile(element)" class="nav-link txt-wrap pointer"
                              [innerHTML]="element.submittedFileName">{{element.submittedFileName}} </a>
                          </div>
                          </td>

                      </ng-container>

                      <ng-container matColumnDef="submittedDateAndTime">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{labelCaption.CPProxyForm_SubmittedDateAndTime}}
                          </th>
                          <td mat-cell *matCellDef="let element" [ngStyle]="{'background-color':element.isSuperseded ?'normal':'#ccd0d3', 'text-decoration': !element.isSuperseded ? 'line-through' : 'none' }">  
                            {{element.submittedDateAndTime}} 
                          </td>
                      </ng-container>

                      <ng-container matColumnDef="submittedBy"> 
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{labelCaption.CPProxyForm_SubmittedBy}}
                          </th>
                          <td mat-cell *matCellDef="let element" [ngStyle]="{'background-color':element.isSuperseded ?'normal':'#ccd0d3' }" >
                          <div class="txt-wrap" [ngStyle]="{'text-decoration': !element.isSuperseded ? 'line-through' : 'none'}">
                              {{element.submittedBy}} 
                              <div class="tooltiptext" [innerHTML]="element.engagement"></div>
                          </div>
                          </td>
                      </ng-container>
              
              
                  <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayColumns;" [ngClass]="getRowClass(row)"></tr>
                </table>
              </div>
              <ng-container *ngIf="totalCountLength == 0">
                  <div class="empty-table-content pt-3">
                      <p class="claim_status">No Record</p>
                  </div>
              </ng-container>
              <app-paginator *ngIf="totalCountLength>=10" [total-length]="totalCountLength"
              (emitData)="emitPaginatorSplice($event)">
              </app-paginator> 
            <div class="row my-5">
              <div class="col-md-12">
                <button type="button" class="secondary-button" (click)="onClickToRedirectToHomepage()">HOME</button>
              </div>
            </div>
        </div>
      </div>
    </div>
    
  </div>


